import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { Resizable } from 're-resizable';
import {
  useAssetTypesConfiguration,
  useFeatureFlag,
  AssetTypesConfigurationContext
} from '@mulesoft/exchange-react-hooks';
import { Layout } from '@mulesoft/exchange-ui-components/lib/components/Layout';
import { selectors as sessionSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/session';
import { AssetPortalsLayout } from '@mulesoft/exchange-ui-portals-common';
import AssetDetailSidebar from '~/layouts/common/Sidebar';
import styles from './AssetDetailWrapper.css';
import ProductHeading from '../../../components/ProductHeading';
import { useFederatedModule } from '../../../components/hooks';
import { mergeFormDefinitions } from '~/utils/types';

const resizableEnable = { right: true };
const resizableDefaultSize = { width: 250 };

const AssetDetailWrapper = ({ route, routes, asset, isPageComponent }) => {
  const isMobile = global.innerWidth <= 991;
  const isPortalReArchitectureEnabled = useSelector(
    sessionSelectors.isPIRAEnabled
  );
  const typeVersion = useFeatureFlag(`${asset.type}-version`);
  const { federatedContent } = useFederatedModule(
    'assets_definitions_form',
    './form',
    typeVersion
  );
  const assetTypesConfiguration = useAssetTypesConfiguration();
  const mergedConfigurations = React.useMemo(() => {
    return mergeFormDefinitions(assetTypesConfiguration, federatedContent);
  }, [assetTypesConfiguration, federatedContent]);

  const renderSidebar = () => (
    <AssetDetailSidebar route={route} asset={asset} />
  );

  const renderRoutesFn = () => renderRoutes(route.routes, { route, routes });

  return isPortalReArchitectureEnabled ? (
    <AssetTypesConfigurationContext.Provider value={mergedConfigurations}>
      <AssetPortalsLayout
        renderRoutes={renderRoutesFn}
        renderSidebar={renderSidebar}
        asset={asset}
        isPageComponent={isPageComponent}
      />
    </AssetTypesConfigurationContext.Provider>
  ) : (
    <Layout>
      <Resizable
        defaultSize={resizableDefaultSize}
        minWidth={200}
        maxWidth={400}
        className={styles.sidebar}
        enable={isMobile ? false : resizableEnable}
      >
        <div id="sidebar" data-test-id="sidebar">
          <ProductHeading isSidebarItem />
          <AssetDetailSidebar route={route} asset={asset} />
        </div>
      </Resizable>
      <AssetTypesConfigurationContext.Provider value={mergedConfigurations}>
        {renderRoutes(route.routes, { route, routes })}
      </AssetTypesConfigurationContext.Provider>
    </Layout>
  );
};

AssetDetailWrapper.propTypes = {
  route: PropTypes.object,
  routes: PropTypes.arrayOf(PropTypes.object),
  asset: PropTypes.object,
  isPageComponent: PropTypes.bool
};
export default AssetDetailWrapper;
